import baseAPI from '@/api/base';
import { LoginCredentals, SignupCredentals } from '@/dtos/auth.dto';
import {
  EDIT_EMPLOYEE_URL,
  FORGOT_PASSWORD_URL,
  LOGIN_URL,
  LOGOUT_URL,
  RESET_PASSWORD,
  RESET_PASSWORD_AUTHED_URL,
  SIGNUP_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';
import {
  EditEmployee,
  ForgotPassword,
  ResetPassword,
  ResetPasswordObj,
} from '@/dtos/employee.dto';

class Auth {
  static login = async (
    loginCredentals: LoginCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(LOGIN_URL, {
      ...loginCredentals,
    });
    console.log('response', response);
    return response;
  };

  /** Tells the activity log the employee signed out; the session itself is only forgotten here. */
  static logout = async (): Promise<AxiosResponse> =>
    baseAPI.post(LOGOUT_URL, {}, { silent: true, timeout: 5000 });

  static signup = async (
    registrationCredentals: SignupCredentals
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(SIGNUP_URL, {
      ...registrationCredentals,
    });
    console.log('response', response);
    return response;
  };

  static forgotPassword = async (
    forgotPassword: ForgotPassword
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(FORGOT_PASSWORD_URL, {
      ...forgotPassword,
    });
    return response;
  };

  static resetPassword = async (
    resetPassword: ResetPasswordObj
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      `${RESET_PASSWORD}/${resetPassword.token}`,
      {
        ...resetPassword.resetPasswordObj,
      }
    );
    return response;
  };

  static resetPasswordAuthed = async (
    resetPassword: ResetPassword
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      RESET_PASSWORD_AUTHED_URL,
      {
        ...resetPassword,
      }
    );
    return response;
  };

  static updateAccount = async (editEmployee: EditEmployee): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_URL, {
      ...editEmployee,
    });
    return response;
  };
}

export default Auth;
